import React from 'react';
import styles from './commercePage.module.sass';
import {CommerceOptions} from "./commerceOptions";
import {CommerceContent} from "./commerceContetnt";

export const CommercePage = () => {
    return (
        <div className={styles.section}>
            <CommerceOptions/>
            <CommerceContent/>
        </div>
    );
};

